import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'inList',
  standalone: true,
})
export class InListPipe<T> implements PipeTransform {
  public transform(value: T, list: T[]): boolean {
    if (!list || list.length === 0) {
      return false;
    } else {
      return list.indexOf(value) >= 0;
    }
  }
}
